import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ExportConversationIcon = (props: IconProps) => (
  <Icon w="18px" h="18px" viewBox="0 0 18 18" {...props}>
    <path d="m12 3.75-1.065 1.065-1.1925-1.1925V12h-1.485V3.6225L7.065 4.815 6 3.75l3-3 3 3Zm3 3.75v8.25c0 .825-.675 1.5-1.5 1.5h-9c-.8325 0-1.5-.675-1.5-1.5V7.5C3 6.6675 3.6675 6 4.5 6h2.25v1.5H4.5v8.25h9V7.5h-2.25V6h2.25c.825 0 1.5.6675 1.5 1.5Z" />
  </Icon>
);

export default memo(ExportConversationIcon);
